module.exports = __webpack_public_path__ + "static/media/stats-2.1060e2e9.svg";